import React, { Component } from 'react';
import classNames from 'classnames';
import Card from './Card';
import FullbleedWrapper from './FullbleedWrapper';

export default class ProductSpotlight extends Component {
  render() {
    const {
      backgroundColor,
      bodyFontSize,
      overlayColor,
      links,
      images,
      textColor,
      copy,
      className,
      header,
      subHeader: eyebrowHeader,
    } = this.props;
    return (
      <FullbleedWrapper
        backgroundColor={overlayColor}
      >
        <div className={classNames('spotlight', className)}>
          <Card
            key={2}
            bodyFontSize={bodyFontSize || 'XL'}
            className="asset"
            images={images}
            textColor={textColor}
            backgroundColor={backgroundColor}
          />
          <Card
            key={1}
            bodyFontSize={bodyFontSize || 'XL'}
            className="content"
            eyebrowHeader={eyebrowHeader}
            header={header}
            overlayColor={overlayColor}
            textColor={textColor}
            copy={copy}
            links={links}
          />
        </div>
      </FullbleedWrapper>
    );
  }
}
